import classNames from "classnames";
import React from "react";
import "./style.less";

export type HintProps = {
  hint: string;
  className?: string;
};

const Hint = (props: HintProps) => (
  <span dangerouslySetInnerHTML={{ __html: props.hint }} className={classNames("wsc_hint", props.className)} />
);
export default Hint;
